module.exports = __webpack_public_path__ + "static/media/pontem2.c88eb936.png";